// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"3cd75055","885":"ac7149b7"}[chunkId] + ".chunk.js";
};